import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { logAndThrowError } from '../../utils/errors';
export const useUpdateTransactionNotesApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['transactions', budgetId];
    // api call
    const updateTransactionNotesApi = async (data) => {
        await api.post('/account/transaction/notes', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No transactions data found');
        }
        // Create a new array with updated notes for matching transaction IDs
        return oldData.map((transaction) => {
            if (request.transactionIds.includes(transaction.id)) {
                return {
                    ...transaction,
                    notes: request.notes,
                };
            }
            return transaction;
        });
    };
    return useQueryMutation(updateTransactionNotesApi, queryKey, onMutate, options);
};
